import { rgbOrRgbaToHSLA } from './rgbOrRgbaToHSLA';
import { hexOrHexAToRgba } from './hexOrHexAToRgba';
export const hexOrHexAToHSLA = (color) => rgbOrRgbaToHSLA(hexOrHexAToRgba(color));
